export const toggleLoader = (toggler) => ({
    type: 'TOGGLE_LOADER',
    toggler
});